
import { Box, Divider, Grid, Typography } from "@mui/material";
import React, { Fragment, useState } from "react";
import { Plans, TimeBlocks, TopUpServices } from "../../common/const";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import CommonCard from "../../common/components/CommonCard";
import CommonDialog from "../../common/components/CommonDialog";
import { Close } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const StudentPlan = ({
    label,
    examType
}) => {
    const navigate = useNavigate();
    const [addSession, setAddSession] = useState(false);
    const [successOpen, setSuccess] = useState(false);
    const activePlan = Plans.find((a) => a.isActive);
    const [selectedService, setSelectedServices] = useState(TopUpServices[0].label);
    const [timing, selectTiming] = useState(TimeBlocks[0].value);


    if (!activePlan) {
        return (
            <Box
                sx={{
                    background: 'white',
                    borderRadius: 2,
                    padding: 2,
                    textAlign: 'center'
                }}
            >
                <img src="/Images/NoActivePlan.png" alt="NoActivePlan" />
                <Typography fontWeight={600} fontSize={17}>No Active Plan</Typography>
                <Typography fontSize={15} color={theme.palette.background.dark}>Your free plan is expiring soon, get benefits of our plans, explain about the plan.</Typography>
                <CommonButton
                    label="Subscribe a Plan(Gold/Platinum/Diamond)"
                    marginBottom="0px"
                    height="30px"
                    marginTop={2}
                    fontWeight={600}
                />
            </Box>
        );
    }

    return (
        <Fragment>
            <CommonDialog
                open={successOpen}
                size="xs"
                title={
                    <Fragment>
                        <Close
                            sx={{
                                color: theme.palette.background.dark, fontSize: 20,
                                float: 'right',
                                cursor: 'pointer'
                            }}
                            onClick={() => {
                                setSuccess(false);
                                setAddSession(true);
                            }}
                        />
                    </Fragment>
                }
                content={(
                    <center>
                        <img
                            src='/Images/success.png'
                            alt='Check Circle'
                            style={{ width: '70px', height: '70px', marginTop: 20 }}
                        />
                        <Typography sx={{ fontWeight: 600, fontSize: '22px', mt: 0.5 }}>
                            Hours Added Successfully
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph mt={0.3}>
                            You have added {TimeBlocks.find((a) => a.value === timing)?.time}s to your project Mentoring Balance
                        </Typography>
                        <CommonCard
                            paddingBottom="0px"
                            borderRadius={2}
                            background="#FAFAFA"
                            content={
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Box display="flex" justifyContent="space-between">
                                            <Typography fontWeight={600}>Available Sessions</Typography>
                                            <Typography fontWeight={600} color="#10AE2D">+ {TimeBlocks.find((a) => a.value === timing)?.time}s</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CommonCard
                                            paddingBottom="0px"
                                            padding="10px 10px 5px 10px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            content={
                                                <Box textAlign="left">
                                                    <Typography fontWeight={600}>02</Typography>
                                                    <Typography color="background.dark">Previous</Typography>
                                                </Box>
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <CommonCard
                                            paddingBottom="0px"
                                            padding="10px 10px 5px 10px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            content={
                                                <Box textAlign="left">
                                                    <Typography fontWeight={600}>{Number(TimeBlocks.find((a) => a.value === timing)?.time?.split(' ')?.[0]) + 2} Hours</Typography>
                                                    <Typography color="background.dark">Updated</Typography>
                                                </Box>
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            }
                        />
                    </center>
                )}
                actionButtons={(
                    <CommonButton
                        label="Return To Dashboard"
                        size="small"
                        marginBottom="10px"
                        handleClick={() => {
                            navigate('/dashboard');
                            setSuccess(false);
                            setAddSession(false);
                            setSelectedServices(TopUpServices[0].label);
                            selectTiming(TimeBlocks[0].value);
                        }}
                    />
                )}
            />
            <CommonDialog
                open={addSession}
                size="md"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 600, fontSize: 18 }}>Top up Your Session</Typography>
                            <Close
                                sx={{
                                    color: theme.palette.background.dark, fontSize: 20,
                                    float: 'right',
                                    cursor: 'pointer'
                                }}
                                onClick={() => {
                                    setAddSession(false);
                                    setSelectedServices(TopUpServices[0].label);
                                    selectTiming(TimeBlocks[0].value);
                                }}
                            />
                        </Box>
                        <Box width="80%" mb={1}>
                            <Typography sx={{ fontSize: 12 }} color={theme.palette.background.dark}>Purchase additional hours for your plan</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container spacing={1} mt={0.1}>
                        <Grid item md={12}>
                            <Typography fontWeight={600}>Which service do you need more time for?</Typography>
                        </Grid>
                        {(examType ? TopUpServices.filter((i) => i.examType === examType || i?.examType?.includes(examType)) : TopUpServices).map((a, index) => (
                            <Grid item xs={examType ? 12 : 2.4} key={index} onClick={() => setSelectedServices(a.label)}>
                                <CommonCard
                                    paddingBottom="0px"
                                    borderRadius={2}
                                    marginTop="0px"
                                    height="100px"
                                    border={!examType && `3px solid ${selectedService === a.label ? a.color === 'white' ? theme.palette.primary.main : a.color : '#000001A'}`}
                                    background={a.background}
                                    content={
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',           // Take full height of parent
                                                width: '100%',            // Take full width of parent
                                                flexDirection: 'column',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <img src={a.image} alt="icon" />
                                            <Typography mt={0.5} fontSize={14} color={a.color}>
                                                {a.label}
                                            </Typography>
                                        </Box>
                                    }
                                />
                            </Grid>
                        ))}
                        <Grid item md={12}>
                            <Typography fontWeight={600}>Choose a Time Block</Typography>
                        </Grid>
                        {TimeBlocks.map((a, index) => (
                            <Grid item xs={3} key={index} onClick={() => selectTiming(a.value)}>
                                {a.popular ? (
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: 'fit-content'
                                        }}
                                    >
                                        <CommonCard
                                            paddingBottom="0px"
                                            borderRadius={2}
                                            marginTop="0px"
                                            background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                                            content={
                                                <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                                                    <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                                                    <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                                                    <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                                                </Box>
                                            }
                                        />
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '-9px',
                                                right: '65px',
                                                backgroundColor: '#D08700',
                                                color: 'white',
                                                padding: '2px 10px',
                                                borderRadius: '12px',
                                                fontSize: '10px',
                                                zIndex: 10
                                            }}
                                        >
                                            Most Popular
                                        </Box>
                                    </Box>
                                ) : (
                                    <CommonCard
                                        paddingBottom="0px"
                                        borderRadius={2}
                                        marginTop="0px"
                                        background={timing === a.value ? theme.palette.secondary.main : '#FFEECF'}
                                        content={
                                            <Box display="flex" alignItems="center" flexDirection="column" justifyContent="center">
                                                <Typography fontSize={15} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : 'black'}>{a.time}</Typography>
                                                <Typography fontSize={17} textAlign="center" fontWeight={600} color={timing === a.value ? 'white' : theme.palette.primary.main}>{a.value}</Typography>
                                                <Typography fontSize={14} textAlign="center" color={timing === a.value ? 'white' : theme.palette.background.dark}>{a.label}</Typography>
                                            </Box>
                                        }
                                    />
                                )}
                            </Grid>
                        ))}
                    </Grid>
                }
                actionButtons={(
                    <Box display="flex" justifyContent="space-between" width="100%" mt={2}>
                        <Box>
                            <Typography fontWeight={600}>{selectedService}</Typography>
                            <Box display="flex" gap={1}>
                                <Typography color={theme.palette.background.dark}>{TimeBlocks.find((a) => a.value === timing)?.time} - </Typography>
                                <Typography color={theme.palette.secondary.main} fontWeight={600}>{timing}</Typography>
                            </Box>
                        </Box>
                        <CommonButton
                            label="Proceed To Payment"
                            size="small"
                            background={theme.palette.secondary.main}
                            color={theme.palette.background.main}
                            fontWeight={700}
                            marginBottom="10px"
                            width="180px"
                            handleClick={() => {
                                setSuccess(true);
                            }}
                        />
                    </Box>
                )}
            />

            <Box
                sx={{
                    background: 'white',
                    borderRadius: 2,
                    padding: 2,
                    mt: 2
                }}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Box>
                        <Typography fontWeight={600} fontSize={18}>
                            {label}
                        </Typography>
                    </Box>
                </Box>
                <Grid container spacing={1} mb={2}>
                    <Grid item md={4}>
                        <CommonCard
                            paddingBottom="0px"
                            borderRadius={1}
                            marginTop={1}
                            background="#FAFAFA"
                            content={
                                <Box display="flex" alignItems="center" flexDirection="column">
                                    <Typography color="#10AE2D" fontWeight={600}>
                                        40
                                    </Typography>
                                    <Typography color="background.dark" textAlign="center">Total Session</Typography>
                                </Box>
                            }
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonCard
                            paddingBottom="0px"
                            borderRadius={1}
                            marginTop={1}
                            background="#FAFAFA"
                            content={
                                <Box display="flex" alignItems="center" flexDirection="column">
                                    <Typography fontWeight={600} color="#FF8D28">
                                        20
                                    </Typography>
                                    <Typography color="background.dark" textAlign="center">Used</Typography>
                                </Box>
                            }
                        />
                    </Grid>
                    <Grid item md={4}>
                        <CommonCard
                            paddingBottom="0px"
                            borderRadius={1}
                            marginTop={1}
                            background="#FAFAFA"
                            content={
                                <Box display="flex" alignItems="center" flexDirection="column">
                                    <Typography fontWeight={600} color="#0088FF">
                                        20
                                    </Typography>
                                    <Typography color="background.dark" textAlign="center">Remaining</Typography>
                                </Box>
                            }
                        />
                    </Grid>
                </Grid>
                <CommonButton
                    label="Add More Sessions"
                    marginBottom="0px"
                    height="30px"
                    fontWeight={600}
                    handleClick={() => setAddSession(true)}
                />
            </Box>
        </Fragment>
    );
}

export default StudentPlan;